import { ELSRestClientHelper, ELSCommonConfig, ELSLoggingService } from '@els/els-ui-common-react';
export var apiErrorHandler = function (error, defaultIfError) {
    ELSLoggingService.error('', error.message, error);
    return defaultIfError;
};
export var withApiErrorHandler = function (promiseFunction, defaultIfError) {
    return promiseFunction()
        .then(function (res) { return res.data; })
        .catch(function (err) { return apiErrorHandler(err, defaultIfError); });
};
var baseFacadeApi = function (baseUrl) {
    if (baseUrl === void 0) { baseUrl = function () { return "".concat(ELSCommonConfig.buildUrl); }; }
    return {
        get facadeUrl() {
            return baseUrl();
        },
        get: function (url, options) {
            if (options === void 0) { options = {}; }
            return ELSRestClientHelper.get("".concat(baseUrl()).concat(url), options);
        },
        post: function (url, options) {
            if (options === void 0) { options = {}; }
            return ELSRestClientHelper.post("".concat(baseUrl()).concat(url), options);
        },
        put: function (url, options) {
            if (options === void 0) { options = {}; }
            return ELSRestClientHelper.put("".concat(baseUrl()).concat(url), options);
        },
        patch: function (url, options) {
            if (options === void 0) { options = {}; }
            return ELSRestClientHelper.patch("".concat(baseUrl()).concat(url), options);
        },
        delete: function (url, options) {
            if (options === void 0) { options = {}; }
            return ELSRestClientHelper.delete("".concat(baseUrl()).concat(url), options);
        }
    };
};
export var facadeApi = baseFacadeApi(function () { return "".concat(ELSCommonConfig.buildUrl, "/api"); });
export var perFacadeApi = baseFacadeApi(function () { return "".concat(ELSCommonConfig.buildUrl, "/api/performancereport"); });
export var tokenServiceApi = baseFacadeApi(function () { return "".concat(ELSCommonConfig.buildUrl).concat(ELSCommonConfig.tokenServicePath); });
export var hesiNGFacadeApi = baseFacadeApi(function () { return "".concat(ELSCommonConfig.buildUrl, "/api/hesi/app"); });
export var snowflakeFacadeApi = baseFacadeApi(function () { return "".concat(ELSCommonConfig.buildUrl, "/api/snowflake"); });
